<div class="systemAlarmsPage" *ngIf="('ControlAlarmasSistema' | permissionFilter)">
  <div class="container-component">
        <system-alarms-list class="systemAlarms-list"></system-alarms-list>
    </div>
</div>
<div *ngIf="!('ControlAlarmasSistema' | permissionFilter) ">
  <br><br><br><br>
  <h1 class="error">User not Authorized to enter this page</h1>
</div>